
	<div class="col-lg-3 col-md-6 col-xs-12">
		<alert [alert]="msg"></alert>
	  <h1>dashboard</h1>
	</div>
  